module.exports = __webpack_public_path__ + "static/media/badge-waiting.d65b7307.svg";